module.exports = __webpack_public_path__ + "static/media/is.dd962255.svg";